<template>
  <section>
    <h2 class="h2Title">{{ $route.params.bannerCategory.replace("TYPE_", "").replace("_"," ") }} 배너 관리</h2>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">

              <dl>
                <dd>
                  <date-range-component v-on:event="getSearchDate" label="배너 생성일"
                                        :value="param.searchDate"></date-range-component>
                </dd>
                <dd>
                  <div class="monthBx">
                    <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                            :class="{ active: month === activeItem}"
                            @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                    </button>
                  </div>
                </dd>
              </dl>


              <dl>
                <dd>
                  <v-col sm="6">
                    <v-text-field label="제목 / 이미지 설명 검색"
                                  v-model="param.searchKeyword" v-on:keyup.enter="search"
                                  dense clearable flat outlined/>
                  </v-col>
                </dd>
              </dl>

            </li>
          </ul>
        </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
        </p>
        <div class="tableBtn">
          <ul>
            <li class="tableBtnList">
              <v-btn class="vBtn vIconResize mgr" @click="createForm" dark>
                <v-icon left>mdi mdi-playlist-plus</v-icon>
                등록
              </v-btn>
            </li>
          </ul>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="datasets"
            :server-items-length="totalItems"
            :options.sync="options"
            item-key="bannerId"
            class="elevation-1"
            disable-sort
        >
          <template v-slot:body="props">
            <draggable
                :list="datasets"
                @change="changeOrder"
                tag="tbody"
            >
              <tr
                  v-for="(item, index) in props.items"
                  :key="index"
              >
                <td>
                  <v-icon
                      small
                      class="page__grab-icon"
                  >
                    mdi-arrow-all
                  </v-icon>
                </td>

                <td style="text-align: left !important;">
                    <img :src="`${staticPath}/banner/${item.bannerImage}`" style="max-width: 243px; max-height: 100px;"/>
                    {{ item.title }}
                </td>
                <td>
                  {{ item.activated ? '노출' : '미노출' }}
                </td>

                <td>
                  {{ item.createdAt | moment('YYYY-MM-DD HH:mm:ss') }}
                </td>

                <td>
                  {{ item.createdBy }}
                </td>


                <td>
                  <v-icon
                      small
                      class="mr-2"
                      @click.stop="updateForm(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                      small
                      @click.stop="deleteBanner(item)"
                  >
                    mdi-delete
                  </v-icon>
                </td>
              </tr>

            </draggable>
          </template>

        </v-data-table>
      </div>
    </article>

  </section>
</template>

<script>
import DateRageComponent from "@/views/component/DateRageComponent";

import bannerApi from '@/api/BannerApi'
// import _ from "lodash";
import draggable from "vuedraggable";

export default {
  name: "Banner",
  components: {
    'date-range-component': DateRageComponent,
    draggable,
  },
  data: () => ({
    staticPath: process.env.VUE_APP_ATTACH_STATIC_PATH,
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    activeItem: null,
    selected: [],
    headers: [
      {text: '순서', align: 'center', sortable: false},
      {text: '이미지', value: 'title', align: 'left'},
      {text: '노출여부', value: 'activated', align: 'center'},
      {text: '등록일', value: 'createdAt', align: 'center'},
      {text: '등록자', value: 'createdBy', align: 'center'},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    param: {
      searchDate:[],
      searchKeyword: null,
      page: 1
    },
    datasets: [],
    totalItems: 0,
    dialogVisible: false,
    waitingSearch: false,
    options:{}
  }),
  watch: {
    options: {
      handler () {
        this.search();
      },
      deep: true,
    },
    'param.searchKeyword': {
      handler(nv) {
        this.options.page = 1;
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      },
      deep: true
    },
    'param.searchDate': {
      handler() {
        this.search();
      },
      deep: true
    }
  },
  methods: {
    changeOrder(e) {
      const {  page, size } = this.options;
      const newOrder = this.totalItems - (page-1)*size - e.moved.newIndex - 1;
      // console.log(e);
      // console.log(this.totalItems);
      // console.log(newOrder);

      bannerApi.order(e.moved.element.bannerId, newOrder).then(() => {
        this.search();
      });
    },
    onRowClick(value) {
      this.$router.push({path:`/banner/${value}`});
    },
    getSearchDate(searchDate = []) {
      this.param.searchDate = searchDate;
    },
    selectItem(months) {
      this.activeItem = months;
      // 0 is total
      if (this.activeItem !== 0) {
        this.param.searchDate = [this.$moment().subtract(months, "months").format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      } else
        this.param.searchDate = [];
    },
    search() {
      const {  page, itemsPerPage, size } = this.options;

      let params = {...this.param, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};

      if (this.param.searchDate?.length??0 > 0) {
        params.fromDate = this.param.searchDate[0];
        params.toDate = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      bannerApi.list(this.$route.params.bannerCategory, params).then(data => {
        this.datasets = data.content;
        this.totalItems = data.totalElements;
        this.$store.commit('setParams', params);
      });
    },
    createForm() {
      this.$router.push({path: `${this.$route.params.bannerCategory}/form`})
    },
    updateForm(item) {
      this.$router.push({path:`/banner/${this.$route.params.bannerCategory}/form/${item.bannerId}`});
    },
    deleteBanner(item) {
      if(confirm('삭제하시겠습니까?')) {
        bannerApi.delete(item.bannerId).then(() => {
          this.search();
        });
      }
    }
  },
  created: function () {

    const storedParams = this.$store.getters?.params??{};
    if(storedParams.name !== this.$options.name)
      this.$store.commit('setParams', Object.assign(this.param, {name:this.$options.name}))
    else {
      this.options = storedParams
      this.param = storedParams
    }

    // console.log(this.$store.state.currentMenu)
    // console.log(this.$store.getters.menu)
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }
              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        //margin-right: 15px;
      }
    }
  }
}
</style>
